<template>
  <div class="editPage">
    <qx-card :title="pageTitle">
      <Merchant ref="merchant" @getOtherFormVal="getOtherFormVal" />
      <BaseForm ref="baseForm" @getOtherFormVal="getOtherFormVal" />
      <Settlement ref="settlement" @getOtherFormVal="getOtherFormVal" />
    </qx-card>
    <SubBtnBox @sub="sub" />
  </div>
</template>

<script>
import BaseForm from './base';
import Merchant from './merchant';
import Settlement from './settlement';
import SubBtnBox from 'components/subBtnBox';
import {
  siteEdit,
  siteDetail,
} from 'api/service';
import pageDataMixin from '@qx/mixin/pageData';
export default {
  mixins: [
    pageDataMixin,
  ],
  components: {
    BaseForm,
    Merchant,
    Settlement,
    SubBtnBox,
  },
  data () {
    return {
      pageUrl: '/manage/service/site/self/edit',
      formComponents: ['merchant', 'baseForm', 'settlement'],
    };
  },
  computed: {
    detailParams () {
      return {
        serviceType: this.$route.query.serviceType,
        productId: this.$route.query.id,
        serviceUserId: this.$route.query.serviceUserId,
        isEdit: 1,
      };
    },
  },
  methods: {
    detailApi: siteDetail,
    editApi: siteEdit,
    async getOtherFormVal ({from, tar}) {
      const tarFormData = await this.$refs[tar].cacheData();
      this.$refs[from].receiveData(tar, tarFormData);
    },
  },
  async mounted () {
    await this.$refs.merchant.getList();
    await this.$refs.baseForm.getList();
    this.getData();
  },
};
</script>

<style scoped lang="scss">
</style>
